import { Grid, Typography, TextField, Button, Divider, Snackbar, Alert, CircularProgress } from "@mui/material";
import { useEffect, useState } from "react";
import { doc, getDoc, setDoc } from "firebase/firestore";
import { db, storage } from "../../../firebase/firebase";
import { ref, uploadBytes, getDownloadURL, deleteObject } from "firebase/storage";
import ImageIcon from '@mui/icons-material/Image';
import DeleteIcon from '@mui/icons-material/Delete';

const campos = [
    { key: "barra_pc_menu",         label: 'Barra PC — texto menú' },
    { key: "barra_cell_menu",       label: 'Barra Cell — texto menú' },
    { key: "cono_titulo_principal", label: 'Reto — título principal' },
    { key: "cono_titulo_clientes",  label: 'Reto — título clientes' },
    { key: "whatsapp_promocion",    label: 'WhatsApp — texto notificación Whatsapp' },
    { key: "pista_cono_titulo",     label: 'Pista cono — título' },
    { key: "horario_lunes",         label: 'Horario — Lunes' },
    { key: "horario_martes",        label: 'Horario — Martes' },
    { key: "horario_miercoles",     label: 'Horario — Miércoles' },
    { key: "horario_jueves",        label: 'Horario — Jueves' },
    { key: "horario_viernes",       label: 'Horario — Viernes' },
    { key: "horario_sabado",        label: 'Horario — Sábado' },
    { key: "horario_domingo",       label: 'Horario — Domingo' },
];

const Seccion_Textos_Dashboard = () => {
    const [valores, setValores]             = useState({});
    const [cargando, setCargando]           = useState(true);
    const [guardando, setGuardando]         = useState(false);
    const [openSnackbar, setOpenSnackbar]   = useState(false);
    const [mensaje, setMensaje]             = useState("");

    // ── imagen opiniones ──
    const [imagenOpiniones, setImagenOpiniones]   = useState(null);
    const [subiendoImagen, setSubiendoImagen]     = useState(false);
    const [eliminandoImagen, setEliminandoImagen] = useState(false);

    useEffect(() => {
        const cargar = async () => {
            try {
                const snap = await getDoc(doc(db, "configuracion", "textos"));
                if (snap.exists()) setValores(snap.data());
            } catch (e) {
                console.error("Error cargando textos:", e);
            } finally {
                setCargando(false);
            }
        };
        cargar();
    }, []);

    const handleCambio = (key, value) => {
        setValores(prev => ({ ...prev, [key]: value }));
    };

    const handleGuardar = async () => {
        setGuardando(true);
        try {
            await setDoc(doc(db, "configuracion", "textos"), valores, { merge: true });
            setMensaje("Textos guardados con éxito ✅");
            setOpenSnackbar(true);
        } catch (e) {
            console.error("Error guardando textos:", e);
        } finally {
            setGuardando(false);
        }
    };

    const handleImagenOpinionesChange = (e) => {
        if (e.target.files[0]) setImagenOpiniones(e.target.files[0]);
    };

    const handleSubirImagenOpiniones = async () => {
        if (!imagenOpiniones) return;
        setSubiendoImagen(true);
        try {
            // Eliminar imagen anterior si existe
            if (valores.opiniones_imagen) {
                try {
                    const segments = valores.opiniones_imagen.split("%2F");
                    const fileName = segments[segments.length - 1].split("?")[0];
                    const oldRef = ref(storage, `opiniones/${decodeURIComponent(fileName)}`);
                    await deleteObject(oldRef).catch(() => {});
                } catch (_) {}
            }

            const storageRef = ref(storage, `opiniones/${Date.now()}_${imagenOpiniones.name}`);
            await uploadBytes(storageRef, imagenOpiniones);
            const url = await getDownloadURL(storageRef);

            await setDoc(doc(db, "configuracion", "textos"), { opiniones_imagen: url }, { merge: true });
            setValores(prev => ({ ...prev, opiniones_imagen: url }));
            setImagenOpiniones(null);
            setMensaje("Imagen de opiniones actualizada ✅");
            setOpenSnackbar(true);
        } catch (e) {
            console.error("Error subiendo imagen:", e);
        } finally {
            setSubiendoImagen(false);
        }
    };

    // ── Eliminar imagen: borra de Storage y limpia el campo en Firestore ──
    const handleEliminarImagenOpiniones = async () => {
        if (!valores.opiniones_imagen) return;
        setEliminandoImagen(true);
        try {
            try {
                const segments = valores.opiniones_imagen.split("%2F");
                const fileName = segments[segments.length - 1].split("?")[0];
                const oldRef = ref(storage, `opiniones/${decodeURIComponent(fileName)}`);
                await deleteObject(oldRef).catch(() => {});
            } catch (_) {}

            await setDoc(doc(db, "configuracion", "textos"), { opiniones_imagen: "" }, { merge: true });
            setValores(prev => ({ ...prev, opiniones_imagen: "" }));
            setImagenOpiniones(null);
            setMensaje("Imagen eliminada. Se mostrará el texto predeterminado ✅");
            setOpenSnackbar(true);
        } catch (e) {
            console.error("Error eliminando imagen:", e);
        } finally {
            setEliminandoImagen(false);
        }
    };

    if (cargando) return <Typography sx={{ pl: 3, pt: 4 }}>Cargando textos...</Typography>;

    return (
        <Grid container justifyContent={'center'} alignItems={'center'} size={{ xs: 12 }} sx={{ px: 0, pt: 3, pb: 6 }}>
            <Grid container justifyContent={'center'} alignItems={'center'} size={{ xs: 12, sm: 12, md: 10 }}>
                <Grid container justifyContent="flex-start" alignItems="flex-start" size={{ xs: 12, sm: 12, md: 10 }} sx={{ maxWidth: 1200, px: 3, pt: 0 }}>
                    {/* ══════════════════════════════════════════
                            IMAGEN OPINIONES — va primero
                        ══════════════════════════════════════════ */}
                    <Grid size={{ xs: 12 }} sx={{ mb: 2 }}>
                        <Typography variant="h6" fontWeight={700} sx={{ mb: 0.5 }}>
                            Opiniones — imagen
                        </Typography>
                        <Typography variant="caption" color="text.secondary" sx={{ display: "block", mb: 1 }}>
                            Cuando hay imagen, reemplaza el título y la descripción de la sección. Si no hay imagen, se muestra el texto predeterminado.
                        </Typography>

                        {/* Preview imagen actual o nueva seleccionada */}
                        {(imagenOpiniones || valores.opiniones_imagen) && (
                            <img
                                src={imagenOpiniones ? URL.createObjectURL(imagenOpiniones) : valores.opiniones_imagen}
                                alt="Preview opiniones"
                                style={{
                                    width: "100%",
                                    maxHeight: 200,
                                    objectFit: "contain",
                                    borderRadius: 8,
                                    border: "1px solid #e0e0e0",
                                    marginBottom: 10,
                                }}
                            />
                        )}

                        <Grid container spacing={1}>
                            {/* Seleccionar / cambiar imagen */}
                            <Grid size={{ xs: 12, sm: 4 }}>
                                <Button
                                    component="label"
                                    variant="outlined"
                                    fullWidth
                                    startIcon={<ImageIcon />}
                                >
                                    {valores.opiniones_imagen ? "Cambiar imagen" : "Seleccionar imagen"}
                                    <input
                                        type="file"
                                        hidden
                                        accept="image/*"
                                        onChange={handleImagenOpinionesChange}
                                    />
                                </Button>
                            </Grid>

                            {/* Subir imagen (solo si hay archivo nuevo seleccionado) */}
                            {imagenOpiniones && (
                                <Grid size={{ xs: 12, sm: 4 }}>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        fullWidth
                                        onClick={handleSubirImagenOpiniones}
                                        disabled={subiendoImagen}
                                        startIcon={subiendoImagen ? <CircularProgress size={18} color="inherit" /> : null}
                                    >
                                        {subiendoImagen ? "Subiendo..." : "Subir imagen"}
                                    </Button>
                                </Grid>
                            )}

                            {/* Eliminar imagen (solo si ya hay una subida) */}
                            {valores.opiniones_imagen && !imagenOpiniones && (
                                <Grid size={{ xs: 12, sm: 4 }}>
                                    <Button
                                        variant="outlined"
                                        color="error"
                                        fullWidth
                                        onClick={handleEliminarImagenOpiniones}
                                        disabled={eliminandoImagen}
                                        startIcon={eliminandoImagen ? <CircularProgress size={18} color="inherit" /> : <DeleteIcon />}
                                    >
                                        {eliminandoImagen ? "Eliminando..." : "Eliminar imagen"}
                                    </Button>
                                </Grid>
                            )}
                        </Grid>
                    </Grid>

                    <Divider sx={{ width: "100%", my: 1 }} />
                    <Grid container size={{ xs: 12 }} sx={{ pb: 2 }}>
                        <Typography variant="h6" fontWeight={700}>
                            Editar textos del sitio
                        </Typography>
                        <Grid container size={{ xs: 12 }}>
                            <Typography variant="body2" color="text.secondary">
                                Los cambios se aplican en toda la página al guardar.
                            </Typography>
                        </Grid>
                    </Grid>

                    <Divider sx={{ width: "100%", mb: 3 }} />

                    <Grid container size={{ xs: 12, sm: 10, md: 8 }} spacing={3} direction="column">

                        {/* ── Campos de texto ── */}
                        {campos.map(({ key, label }) => (
                            <Grid key={key} size={{ xs: 12 }} sx={{ mb: 2 }}>
                                <Typography variant="body2" fontWeight={600} sx={{ mb: 0.5 }}>
                                    {label}
                                </Typography>
                                <TextField
                                    fullWidth
                                    value={valores[key] || ""}
                                    onChange={(e) => handleCambio(key, e.target.value)}
                                    variant="outlined"
                                    size="small"
                                />
                            </Grid>
                        ))}

                        {/* ── Botón guardar textos ── */}
                        <Grid size={{ xs: 12 }} sx={{ mt: 2 }}>
                            <Button
                                variant="contained"
                                color="primary"
                                size="large"
                                onClick={handleGuardar}
                                disabled={guardando}
                                startIcon={guardando ? <CircularProgress size={18} color="inherit" /> : null}
                            >
                                {guardando ? "Guardando..." : "Guardar todos los textos"}
                            </Button>
                        </Grid>
                    </Grid>

                    <Snackbar
                        open={openSnackbar}
                        autoHideDuration={3000}
                        onClose={() => setOpenSnackbar(false)}
                        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
                    >
                        <Alert onClose={() => setOpenSnackbar(false)} severity="success" sx={{ width: "100%" }}>
                            {mensaje}
                        </Alert>
                    </Snackbar>
                </Grid>
            </Grid>
        </Grid>
    );
};

export default Seccion_Textos_Dashboard;
